/* unplugin-vue-components disabled */import script from "./category_month.vue?vue&type=script&setup=true&lang=js"
export * from "./category_month.vue?vue&type=script&setup=true&lang=js"

import "./category_month.vue?vue&type=style&index=0&id=70c3a773&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70c3a773"]])

export default __exports__